"use client"

import type { WhyChooseUsContentProps } from "@/types/types"
import { useState } from "react"
import { Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import "swiper/css"
import "swiper/css/pagination"
import "./whyChooseUs.css"

import { useWhyChooseUs } from "../hooks/useWhyChooseUs"
import { WhyChooseUsItem } from "./WhyChooseUsItem"

export const WhyChooseUsContent = ({ id, title, items = [], className = "" }: WhyChooseUsContentProps) => {
  const { validItems, hasValidItems, swiperConfig } = useWhyChooseUs({
    items,
    componentId: id,
  })

  const [activeIndex, setActiveIndex] = useState<number>(0)

  if (!hasValidItems) {
    return null
  }

  return (
    <div className={`w-full ${className}`} id={id}>
      <div className="mx-auto sm:pb-[7.25rem] sm:pt-[1.75rem]">
        {title && (
          <h2 className="text-center text-2xl font-bold px-4 sm:-px-0 pb-[2.375rem] pt-8 sm:pt-0 sm:leading-[2.1rem] leading-[1.625rem] text-[#333333]">
            {title}
          </h2>
        )}

        {/* Desktop Grid Layout - 5 items per row */}
        <div className="hidden sm:grid sm:grid-cols-5 sm:gap-0 sm:justify-items-center sm:items-start">
          {validItems.map((item, index) => (
            <div key={index} className="sm:px-[5px] w-full">
              <WhyChooseUsItem item={item} />
            </div>
          ))}
        </div>

        {/* Mobile Carousel Layout - 2 slides per view */}
        <div className="block sm:hidden px-4 sm:px-0">
          <Swiper
            modules={[Pagination]}
            loop={swiperConfig.loop}
            pagination={swiperConfig.pagination}
            slidesPerView={2}
            spaceBetween={0}
            className="why-choose-us-swiper w-full"
          >
            {validItems.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="px-[0.3125rem] w-full flex justify-center">
                  <WhyChooseUsItem item={item} isActive={activeIndex === index} onClick={() => setActiveIndex(index)} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}
